// Gedeelde toestand van de gastenpagina: de lijst van de server en het wiegje.
// Elke wijziging maakt nieuwe arrays aan en verwittigt de luisteraars.
import type { GuestGift, ListResponse } from '../shared/api-types.ts';
import { getList } from './api.ts';
import { cleanCart, loadCart, saveCart, type CartLine } from './cart.ts';
import { toast } from './dom.ts';

type Listener = () => void;

let list: ListResponse | null = null;
let cart: CartLine[] = loadCart();
const listeners: Listener[] = [];

export function onChange(fn: Listener): void {
  listeners.push(fn);
}

function notify(): void {
  for (const fn of listeners) fn();
}

export function currentList(): ListResponse | null {
  return list;
}

export function currentCart(): CartLine[] {
  return cart;
}

export function giftById(id: string): GuestGift | undefined {
  return list?.gifts.find((g) => g.id === id);
}

export function cartLineFor(giftId: string): CartLine | undefined {
  return cart.find((l) => l.giftId === giftId);
}

export function setCart(next: CartLine[], msg?: string): void {
  cart = next;
  saveCart(cart);
  notify();
  if (msg) toast(msg);
}

/** Legt het wiegje naast de actuele lijst. Geeft de titels terug die eruit moesten. */
function applyCleanCart(): string[] {
  if (!list) return [];
  const { kept, droppedTitles } = cleanCart(cart, list.gifts);
  const changed = kept.length !== cart.length || kept.some((l, i) => l.amountCents !== cart[i]?.amountCents);
  if (changed) {
    cart = kept;
    saveCart(cart);
  }
  return droppedTitles;
}

/** Haalt de lijst opnieuw op. Geeft de titels terug die uit het wiegje gehaald werden. */
export async function reloadList(): Promise<string[]> {
  list = await getList();
  const dropped = applyCleanCart();
  notify();
  return dropped;
}

export function droppedMessage(titles: string[]): string {
  return `Uit je wiegje gehaald, want iemand was je voor: ${titles.join(', ')}.`;
}
